// Маппинг уровней между UI и API (используем единый enum из сгенерённого клиента)
import { PositionLevelEnum } from '../../../generated-src/client/positions/api';

export type UiLevel = 'Junior' | 'Middle' | 'Senior' | 'Lead';
export type ApiLevel = PositionLevelEnum;

export const UI_LEVEL_FALLBACK: UiLevel = 'Middle';
export const API_LEVEL_FALLBACK: ApiLevel = PositionLevelEnum.MIDDLE;

export const levelMap: Record<ApiLevel, UiLevel> = {
  [PositionLevelEnum.JUNIOR]: 'Junior',
  [PositionLevelEnum.MIDDLE]: 'Middle',
  [PositionLevelEnum.SENIOR]: 'Senior',
  [PositionLevelEnum.LEAD]: 'Lead',
};

export const levelMapReverse: Record<UiLevel, ApiLevel> = {
  Junior: PositionLevelEnum.JUNIOR,
  Middle: PositionLevelEnum.MIDDLE,
  Senior: PositionLevelEnum.SENIOR,
  Lead: PositionLevelEnum.LEAD,
};

export function mapApiLevelToUi(apiLevel: ApiLevel | string | undefined | null): UiLevel {
  if (!apiLevel) return UI_LEVEL_FALLBACK;
  const normalized = String(apiLevel).toUpperCase() as ApiLevel;
  return levelMap[normalized] ?? UI_LEVEL_FALLBACK;
}

export function mapUiLevelToApi(uiLevel: UiLevel | string | undefined | null): ApiLevel {
  if (!uiLevel) return API_LEVEL_FALLBACK;
  const normalized = (uiLevel as UiLevel);
  return levelMapReverse[normalized] ?? PositionLevelEnum.MIDDLE;
}


// Маппинг уровня в минимальную оценку для автозаполнения при генерации
export function mapLevelToMinScore(uiLevel: UiLevel | string | undefined | null): number {
  const level = (uiLevel as UiLevel) || UI_LEVEL_FALLBACK;
  switch (level) {
    case 'Junior':
      return 3;
    case 'Middle':
      return 4;
    case 'Senior':
      return 5;
    case 'Lead':
      return 6;
    default:
      return 4; // безопасный дефолт
  }
}

// Вариант напрямую из енама API → минимальная оценка (без преобразования в UI)
export function mapApiEnumLevelToMinScore(apiLevel: ApiLevel | null | undefined): number {
  const level = apiLevel ?? API_LEVEL_FALLBACK;
  switch (level) {
    case PositionLevelEnum.JUNIOR:
      return 3;
    case PositionLevelEnum.MIDDLE:
      return 4;
    case PositionLevelEnum.SENIOR:
      return 5;
    case PositionLevelEnum.LEAD:
      return 6;
    default:
      return 4;
  }
}


